export const DEFAULT_BASEURL = `https://${process.env.GATSBY_HOST}`
export const WORKSPACE_BASEURL_PUT = `https://h29waticma.execute-api.us-east-1.amazonaws.com/intermediate`
export const WORKSPACE_BASEURL = `https://${process.env.GATSBY_WORKSPACE_HOST}`
export const WORKSPACE_ENDPOINT = `/${process.env.GATSBY_STAGE}/workspace`
export const WORKSPACE_ENDPOINT_PUT = `/workspaces`
export const ADD_WORKSPACE_ENDPOINT = `/${process.env.GATSBY_STAGE}/addworkspace`
export const USER_ENDPOINT = `/${process.env.GATSBY_STAGE}/user`
export const ELIGIBLE_USER_ENDPOINT = `/${process.env.GATSBY_STAGE}/user/eligible`
export const INSERT_ENDPOINT = `/${process.env.GATSBY_STAGE}/insert`
export const PERMISSION_ENDPOINT = `/${process.env.GATSBY_STAGE}/permission`
export const CATEGORY_ENDPOINT = `/${process.env.GATSBY_STAGE}/workspace/category`
export const DELETE_WORKSPACE_ENDPOINT = '/workspaces/delete'
export const UPDATE_WORKSPACE_ENDPOINT = '/workspaces/update/'
